'use client';

import createTheme from "./createTheme.js";
var defaultTheme = createTheme();
export default defaultTheme;